import React, { useState, useEffect, useContext } from "react";
import Modal from "react-bootstrap/Modal";
import { LoginContext } from "../context/LoginContext";
import useTheme from "./useTheme";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faMoneyBillWave, faPen } from "@fortawesome/free-solid-svg-icons";
import ProgressBar from "react-bootstrap/ProgressBar";

const Price = (props) => {
  const loginContext = useContext(LoginContext);

  const [priceCon, setPriceCon] = useState([]);

  const [showDetail, setShowDetail] = useState(false);

  const [showSignup, setShowSignup] = useState(false);

  const [detailData, setDetailData] = useState([]);

  const [dolarPrice, setDolarPrice] = useState(props.dolar);

  const [goldPrice, setGoldPrice] = useState(props.gold);

  const [sekkePrice, setSekkePrice] = useState(props.sekke);

  const [product, setProduct] = useState(props.product);

  const [mobile, setMobile] = useState("");

  const [pass, setPass] = useState("");

  const [name, setName] = useState("");

  const [mobileValidate, setMobileValidate] = useState(true);

  const [passValidate, setPassValidate] = useState(true);

  const [nameValidate, setNameValidate] = useState(true);

  const [exist, setExist] = useState(0);

  const [result, setResult] = useState("");

  const [isLoading, setIsLoading] = useState(false);

  const [theme, switchTheme] = useTheme();

  const dastresi = parseInt(loginContext.userInfo.dastresi);

  const p2e = (s) => s.replace(/[۰-۹]/g, (d) => "۰۱۲۳۴۵۶۷۸۹".indexOf(d));
  const a2e = (s) => s.replace(/[٠-٩]/g, (d) => "٠١٢٣٤٥٦٧٨٩".indexOf(d));

  useEffect(() => {
    setProduct(props.product);
    setGoldPrice(props.gold);
    setDolarPrice(props.dolar);
    setSekkePrice(props.sekke);
  }, [props.product, props.gold, props.dolar, props.sekke]);

  const formatNumber = (num) => {
    return num.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,");
  };

  const rond = (value, index) => {
    const ind = parseInt(index);
    let ref = 1;
    for (let i = 0; i < ind; i++) {
      ref = ref * 10;
    }
    if (ref === 1) {
      return parseInt(value);
    } else {
      // return Math.round(parseInt(value) / ref) * ref;
      return Math.floor(parseInt(value) / ref) * ref;
    }
  };

  const mobileHandle = (e) => {
    if (isNaN(e.target.value)) {
      return;
    }
    setMobile(e.target.value);
  };

  const passHandle = (e) => {
    setPass(p2e(a2e(e.target.value)));
  };

  const nameHandle = (e) => {
    setName(e.target.value);
  };

  const checkSignup = () => {
    if (mobile.length < 11 || mobile[0] + mobile[1] != "09") {
      setMobileValidate(false);
      return;
    } else {
      setMobileValidate(true);
    }
    setIsLoading(true);
    const formData = new FormData();
    formData.append("checkSignup", 1);
    formData.append("mobile", mobile);
    formData.append("vitrinCode", props.vitrinCode);
    const req = new Request(
      "https://hamrahvitrin.ir/LiveGallery/process/bonakdari_api.php",
      {
        method: "POST",
        body: formData,
      }
    );
    fetch(req)
      .then((res) => res.json())
      .then((data) => {
        if (data.data) {
          setExist(1);
        } else {
          setExist(2);
        }
        setIsLoading(false);
      })
      .catch((e) => {
        console.log(e);
        setExist(3);
        setResult("اشکال در برقراری ارتباط با سرور");
        setIsLoading(false);
      });
  };

  const login = () => {
    if (pass.length < 4) {
      setPassValidate(false);
      return;
    } else {
      setPassValidate(true);
    }
    setIsLoading(true);
    const formData = new FormData();
    formData.append("login", 1);
    formData.append("mobile", mobile);
    formData.append("password", pass);
    formData.append("vitrinCode", props.vitrinCode);
    const req = new Request(
      "https://hamrahvitrin.ir/LiveGallery/process/bonakdari_api.php",
      {
        method: "POST",
        body: formData,
      }
    );
    fetch(req)
      .then((res) => res.json())
      .then((data) => {
        if (data.result) {
          loginContext.login(data.data);
          setShowSignup(false);
        } else {
          setResult("رمز عبور اشتباه است");
          setExist(3);
        }
        setIsLoading(false);
      })
      .catch((e) => {
        console.log(e);
        setExist(3);
        setResult("اشکال در برقراری ارتباط با سرور");
        setIsLoading(false);
      });
  };

  const forgetPass = () => {
    setIsLoading(true);
    const formData = new FormData();
    formData.append("forget_pass", 1);
    formData.append("mobile", mobile);
    formData.append("vitrinCode", props.vitrinCode);
    const req = new Request(
      "https://hamrahvitrin.ir/LiveGallery/process/bonakdari_api.php",
      {
        method: "POST",
        body: formData,
      }
    );
    fetch(req)
      .then((res) => res.json())
      .then((data) => {
        if (data.result) {
          setResult(data.data);
          setExist(3);
        }
        setIsLoading(false);
      })
      .catch((e) => {
        console.log(e);
        setExist(3);
        setResult("اشکال در برقراری ارتباط با سرور");
        setIsLoading(false);
      });
  };

  const signup = () => {
    if (name.length < 6) {
      setNameValidate(false);
      return;
    } else {
      setNameValidate(true);
    }
    setIsLoading(true);
    const formData = new FormData();
    formData.append("signUp", 1);
    formData.append("mobile", mobile);
    formData.append("name", name);
    formData.append("vitrinCode", props.vitrinCode);
    formData.append("address", "");
    formData.append("work", "مشتری خانگی");
    formData.append("moaref", "");
    const req = new Request(
      "https://hamrahvitrin.ir/LiveGallery/process/bonakdari_api.php",
      {
        method: "POST",
        body: formData,
      }
    );
    fetch(req)
      .then((res) => res.json())
      .then((data) => {
        if (data.result) {
          setExist(4);
        } else {
          setExist(5);
        }
        setResult(data.data);
        setIsLoading(false);
      })
      .catch((e) => {
        console.log(e);
        setExist(5);
        setResult("اشکال در برقراری ارتباط با سرور");
        setIsLoading(false);
      });
  };

  const modal = () => {
    if (!isLoading) {
      if (exist === 0) {
        return (
          <div>
            <h6 className="text-center">موبایل</h6>
            <input
              className={
                !mobileValidate
                  ? "form-control is-invalid rtl"
                  : "form-control rtl"
              }
              type="text"
              inputMode="numeric"
              maxLength="11"
              value={mobile}
              onChange={mobileHandle}
            ></input>
            <div className="mt-3 text-center">
              <button
                className="btn btn-success"
                onClick={() => {
                  checkSignup();
                }}
              >
                ادامه
              </button>
            </div>
          </div>
        );
      } else if (exist === 1) {
        return (
          <div>
            <h6 className="text-center">موبایل</h6>
            <input
              className="form-control rtl"
              type="text"
              inputMode="numeric"
              maxLength="11"
              value={mobile}
              readOnly
            ></input>
            <h6 className=" mt-3 text-center">رمزعبور</h6>
            <input
              className={
                !passValidate
                  ? "form-control is-invalid rtl"
                  : "form-control rtl"
              }
              type="password"
              value={pass}
              onChange={passHandle}
            ></input>
            <div className="mt-3 text-center">
              <button
                className="btn btn-info mr-2"
                onClick={() => {
                  forgetPass();
                }}
              >
                فراوشی رمزعبور
              </button>
              <button
                className="btn btn-success"
                onClick={() => {
                  login();
                }}
              >
                ورود
              </button>
            </div>
          </div>
        );
      } else if (exist === 2) {
        return (
          <div>
            <h6 className="text-center">
              <FontAwesomeIcon
                onClick={() => {
                  setExist(0);
                }}
                icon={faPen}
              />{" "}
              موبایل
            </h6>
            <input
              className="form-control rtl"
              type="text"
              inputMode="numeric"
              maxLength="11"
              value={mobile}
              readOnly
            ></input>
            <h6 className=" mt-3 text-center">نام و نام خانوادگی</h6>
            <input
              className={
                !nameValidate
                  ? "form-control is-invalid rtl"
                  : "form-control rtl"
              }
              type="text"
              value={name}
              onChange={nameHandle}
            ></input>
            <div className="mt-3 text-center">
              <button
                className="btn btn-success"
                onClick={() => {
                  signup();
                }}
              >
                ثبت نام
              </button>
            </div>
          </div>
        );
      } else if (exist === 3) {
        return (
          <div className="text-center">
            <p>{result}</p>
            <button
              className="btn btn-danger"
              onClick={() => {
                setPass("");
                setExist(1);
              }}
            >
              بازگشت
            </button>
          </div>
        );
      } else if (exist === 4) {
        return (
          <div className="text-center">
            <p>{result}</p>
            <button
              className="btn btn-success"
              onClick={() => {
                setExist(1);
              }}
            >
              ورود
            </button>
          </div>
        );
      } else if (exist === 5) {
        return (
          <div className="text-center">
            <p>{result}</p>
            <button
              className="btn btn-success"
              onClick={() => {
                setExist(2);
              }}
            >
              ثبت نام مجدد
            </button>
          </div>
        );
      }
    } else {
      return (
        <div className="row justify-content-center m-5 p-5">
          <div className="spinner-border" role="status">
            <span className="sr-only">Loading...</span>
          </div>
        </div>
      );
    }
  };

  // const setFinalAmount = (pk, amount) => {
  //   props.setProduct((prevState) => {
  //     const newState = [...prevState];
  //     const idx = newState.findIndex((item) => item.pk === pk);
  //     if (idx > -1) {
  //       newState.finalAmount = amount;
  //     }
  //     return newState;
  //   });
  // };

  if (loginContext.loginState) {
    if (dastresi === 2 || dastresi === 3) {
      const takhfif =
        parseFloat(loginContext.userInfo.darsad) +
        parseFloat(product.darsad_takhfif);
      if (props.type === "bar") {
        return null;
      }
      if (product.type === "1") {
        return (
          <div className="row">
            <div className="col-5">{"(ریال) قیمت : "}</div>
            <div className="col-7 text-right">
              {formatNumber(
                rond(
                  product.foroshTedadi,
                  product.rond === "0" ? 4 : product.rond
                )
              )}
            </div>
          </div>
        );
      } else if (
        product.type === "61" ||
        product.type === "62" ||
        product.type === "63" ||
        product.type === "64" ||
        product.type === "65"
      ) {
        if (product.type === "61") {
          return (
            <div className="row">
              <div className="col-5">{"(ریال) قیمت : "}</div>
              <div className="col-7 text-right">
                {formatNumber(
                  rond(
                    sekkePrice.sekkeJadid,
                    product.rond === "0" ? 4 : product.rond
                  )
                )}
              </div>
            </div>
          );
        }
        if (product.type === "62") {
          return (
            <div className="row">
              <div className="col-5">{"(ریال) قیمت : "}</div>
              <div className="col-7 text-right">
                {formatNumber(
                  rond(
                    sekkePrice.sekkeGhadim,
                    product.rond === "0" ? 4 : product.rond
                  )
                )}
              </div>
            </div>
          );
        }
        if (product.type === "63") {
          return (
            <div className="row">
              <div className="col-5">{"(ریال) قیمت : "}</div>
              <div className="col-7 text-right">
                {formatNumber(
                  rond(
                    sekkePrice.sekkeNim,
                    product.rond === "0" ? 4 : product.rond
                  )
                )}
              </div>
            </div>
          );
        }
        if (product.type === "64") {
          return (
            <div className="row">
              <div className="col-5">{"(ریال) قیمت : "}</div>
              <div className="col-7 text-right">
                {formatNumber(
                  rond(
                    sekkePrice.sekkeRob,
                    product.rond === "0" ? 4 : product.rond
                  )
                )}
              </div>
            </div>
          );
        }
        if (product.type === "65") {
          return (
            <div className="row">
              <div className="col-5">{"(ریال) قیمت : "}</div>
              <div className="col-7 text-right">
                {formatNumber(
                  rond(
                    sekkePrice.sekkeGerami,
                    product.rond === "0" ? 4 : product.rond
                  )
                )}
              </div>
            </div>
          );
        }
      } else {
        if (product.ojrat !== "" && product.darsad !== "") {
          if (takhfif > 0) {
            return (
              <>
                <h6>
                  اجرت :
                  <span className="text-warning">
                    {product.ojrat + " ریال  "}
                  </span>
                </h6>
                <div className="row">
                  <div className="col-5">اجرت :</div>
                  <div className="col-7 text-right text-warning">
                    {product.darsad.split("%")[0] - takhfif + " درصد"}
                  </div>
                  <div className="col-12 text-right">
                    <span className="badge badge-pill badge-danger">
                      {takhfif + "%"}
                    </span>
                    <small>
                      <del className="text-muted mr-1">
                        {product.darsad.split("%")[0] + " درصد"}
                      </del>
                    </small>
                  </div>
                </div>
              </>
            );
          } else {
            return (
              <h6>
                اجرت :
                <span className="text-warning">
                  {product.ojrat + " ریال  "}
                </span>
                <span className="text-warning">
                  {product.darsad.split("%")[0] + " درصد"}
                </span>
              </h6>
            );
          }
        } else if (product.ojrat !== "") {
          return (
            <h6>
              اجرت :
              <span className="text-warning">{product.ojrat + " ریال  "}</span>
            </h6>
          );
        } else if (product.darsad !== "") {
          if (takhfif > 0) {
            return (
              <div className="row">
                <div className="col-5">اجرت :</div>
                <div className="col-7 text-right text-warning">
                  {product.darsad.split("%")[0] - takhfif + " درصد"}
                </div>
                <div className="col-12 text-right">
                  <span className="badge badge-pill badge-danger">
                    {takhfif + "%"}
                  </span>
                  <small>
                    <del className="text-muted mr-1">
                      {product.darsad.split("%")[0] + " درصد"}
                    </del>
                  </small>
                </div>
              </div>
            );
          } else {
            return (
              <h6>
                اجرت :
                <span className="text-warning">
                  {product.darsad.split("%")[0] + " درصد"}
                </span>
              </h6>
            );
          }
        } else {
          return null;
        }
      }
    } else if (dastresi === 0 || dastresi === 1) {
      if (
        product.type === "0" ||
        product.type === "2" ||
        product.type === "3" ||
        product.type === "4"
      ) {
        const vazn = parseFloat(product.vazn);
        const ayar = parseInt(product.ayar);
        const ojratDarsad = isNaN(parseFloat(product.darsad.split("%")[0]))
          ? 0
          : parseFloat(product.darsad.split("%")[0]);
        let ojratRial;
        if (product.ojrat !== null) {
          ojratRial = isNaN(parseInt(product.ojrat.replaceAll(",", "")))
            ? 0
            : parseInt(product.ojrat.replaceAll(",", ""));
        } else {
          ojratRial = 0;
        }
        let type = vazn,
          vahed = 1;
        if (product.type === "2") {
          type = 1;
        }
        const dolar = parseInt(dolarPrice);
        if (product.fkArz === "3") {
          vahed = dolar;
        }
        const gold18 = parseInt(goldPrice);
        const poolSang = parseInt(product.mablaghSang);
        const darsadSood = parseInt(product.darsadSood);
        const darsadAfzoode = parseInt(product.darsadAfzode);
        const takhfif =
          parseFloat(loginContext.userInfo.darsad) +
          parseFloat(product.darsad_takhfif);

        const A = Math.round(vazn * gold18 * (ayar / 750));
        const B = Math.round(type * vahed * ojratRial);
        const C = Math.round((ojratDarsad / 100) * gold18 * vazn);
        const ojratGeram = (B + C) / vazn;
        const D = poolSang;
        const sum = A + B + C + D;
        const E = Math.round(sum + (sum * darsadSood) / 100);
        const F = E - (E * takhfif) / 100;

        const rondVal =
          product.rond === "0" || product.rond === "" ? 4 : product.rond;

        let G, H;
        // if (parseInt(rondVal) === 3) {
        //   H = Math.round(E + (E * darsadAfzoode) / 100);
        //   G = Math.round(F + (F * darsadAfzoode) / 100);
        // } else {
        H = Math.round(E + ((E - A) * darsadAfzoode) / 100);
        G = Math.round(F + ((F - A) * darsadAfzoode) / 100);
        // }
        const detailArray = [];
        detailArray.push({ key: "فی طلا", value: formatNumber(gold18) });
        detailArray.push({ key: "وزن", value: vazn });
        detailArray.push({ key: "عیار", value: ayar });
        detailArray.push({
          key: "پول طلا",
          value: formatNumber(rond(A, rondVal)),
        });
        detailArray.push({
          key: "اجرت و سود",
          value: formatNumber(rond(B + C, rondVal)),
        });
        detailArray.push({
          key: "اجرت 1 گرم",
          value: formatNumber(rond(ojratGeram, rondVal)),
        });
        detailArray.push({
          key: "قیمت فروش",
          value: formatNumber(rond(E, rondVal)),
        });
        if (takhfif > 0) {
          detailArray.push({
            key: "تخفیف",
            value:
              takhfif +
              "% - " +
              formatNumber(rond(Math.round((E * takhfif) / 100), rondVal)),
          });
        }
        if (takhfif > 0) {
          detailArray.push({
            key: "ارزش افزوده",
            value:
              parseInt(rondVal) === 3
                ? formatNumber(
                    rond(Math.round((F * darsadAfzoode) / 100), rondVal)
                  )
                : formatNumber(
                    rond(Math.round(((F - A) * darsadAfzoode) / 100), rondVal)
                  ),
          });
        } else {
          detailArray.push({
            key: "ارزش افزوده",
            value:
              parseInt(rondVal) === 3
                ? formatNumber(
                    rond(Math.round((E * darsadAfzoode) / 100), rondVal)
                  )
                : formatNumber(
                    rond(Math.round(((E - A) * darsadAfzoode) / 100), rondVal)
                  ),
          });
        }
        if (takhfif > 0) {
          detailArray.push({
            key: "جمع کل",
            value: formatNumber(rond(G, rondVal)),
          });
          props.product.finalAmount = formatNumber(rond(G, rondVal));
        } else {
          detailArray.push({
            key: "جمع کل",
            value: formatNumber(rond(H, rondVal)),
          });
          props.product.finalAmount = formatNumber(rond(G, rondVal));
        }

        let darsadTala, darsadOjrat;
        if (takhfif > 0) {
          darsadTala = Math.round((A / G) * 100);
          darsadOjrat = Math.round(((G - A) / G) * 100);
        } else {
          darsadTala = Math.round((A / H) * 100);
          darsadOjrat = Math.round(((H - A) / H) * 100);
        }

        if (props.type === "kala") {
          return (
            <table
              className={
                theme === "light"
                  ? "table rtl text-dark"
                  : "table rtl text-light"
              }
            >
              <tbody>
                {detailArray.map((item, index) => (
                  <tr key={index}>
                    <th scope="row">{item.key}</th>
                    <td>{item.value}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          );
        } else {
          if (props.type === "bar") {
            if (!isNaN(darsadTala)) {
              return (
                <div className="mb-3">
                  <ProgressBar>
                    <ProgressBar
                      variant="success"
                      label={`${darsadTala}% طلا`}
                      now={darsadTala}
                      key={1}
                    />
                    <ProgressBar
                      variant="danger"
                      label={`%${darsadOjrat} اجرت`}
                      now={darsadOjrat}
                      key={2}
                    />
                  </ProgressBar>
                </div>
              );
            } else {
              return null;
            }
          } else {
            if (takhfif > 0) {
              return (
                <>
                  <div className="row">
                    <div className="col-5">
                      {"قیمت (ريال): "}
                      <FontAwesomeIcon
                        icon={faMoneyBillWave}
                        size="lg"
                        onClick={() => {
                          setShowDetail(true);
                          setDetailData(detailArray);
                        }}
                      />
                      <Modal
                        show={showDetail}
                        onHide={() => {
                          setShowDetail(false);
                        }}
                        size="lg"
                        aria-labelledby="contained-modal-title-vcenter"
                        centered
                        scrollable
                      >
                        <Modal.Body
                          className={
                            theme === "light"
                              ? "bg-light text-dark"
                              : "bg-dark text-light"
                          }
                        >
                          <table
                            className={
                              theme === "light"
                                ? "table rtl text-dark"
                                : "table rtl text-light"
                            }
                          >
                            <tbody>
                              {detailData.map((item, index) => (
                                <tr key={index}>
                                  <th scope="row">{item.key}</th>
                                  <td>{item.value}</td>
                                </tr>
                              ))}
                            </tbody>
                          </table>
                        </Modal.Body>

                        <Modal.Footer
                          className={
                            theme === "light"
                              ? "bg-light text-dark"
                              : "bg-dark text-light"
                          }
                        >
                          <button
                            className="btn btn-dark"
                            onClick={() => {
                              setShowDetail(false);
                            }}
                          >
                            بستن
                          </button>
                        </Modal.Footer>
                      </Modal>
                      {/* {detail(detailArray)} */}
                    </div>
                    <div className="col-7 text-right">
                      {formatNumber(rond(G, rondVal))}
                    </div>
                    <div className="col-12 text-right">
                      <span className="badge badge-pill badge-danger">
                        {takhfif + "%"}
                      </span>
                      <small>
                        <del className="text-muted mr-1">
                          {formatNumber(rond(H, rondVal))}
                        </del>
                      </small>
                    </div>
                  </div>
                </>
              );
            } else {
              return (
                <>
                  <div className="row">
                    <div className="col-5">
                      {"قیمت (ريال): "}
                      <FontAwesomeIcon
                        icon={faMoneyBillWave}
                        size="lg"
                        onClick={() => {
                          setShowDetail(true);
                          setDetailData(detailArray);
                        }}
                      />
                      <Modal
                        show={showDetail}
                        onHide={() => {
                          setShowDetail(false);
                        }}
                        size="lg"
                        aria-labelledby="contained-modal-title-vcenter"
                        centered
                        scrollable
                      >
                        <Modal.Body
                          className={
                            theme === "light"
                              ? "bg-light text-dark"
                              : "bg-dark text-light"
                          }
                        >
                          <table
                            className={
                              theme === "light"
                                ? "table rtl text-dark"
                                : "table rtl text-light"
                            }
                          >
                            <tbody>
                              {detailData.map((item, index) => (
                                <tr key={index}>
                                  <th scope="row">{item.key}</th>
                                  <td>{item.value}</td>
                                </tr>
                              ))}
                            </tbody>
                          </table>
                        </Modal.Body>

                        <Modal.Footer
                          className={
                            theme === "light"
                              ? "bg-light text-dark"
                              : "bg-dark text-light"
                          }
                        >
                          <button
                            className="btn btn-dark"
                            onClick={() => {
                              setShowDetail(false);
                            }}
                          >
                            بستن
                          </button>
                        </Modal.Footer>
                      </Modal>
                      {/* {detail(detailArray)} */}
                    </div>
                    <div className="col-7 text-right">
                      {formatNumber(rond(H, rondVal))}
                    </div>
                  </div>
                </>
              );
            }
          }
        }
      } else if (product.type === "1") {
        const rondVal =
          product.rond === "0" || product.rond === "" ? 4 : product.rond;
        // const array = [...priceContext.price];
        // array.push({
        //   pk: product.pk,
        //   price: formatNumber(
        //     rond(Math.round(parseInt(product.ojrat.replaceAll(",", ""))), rondVal)
        //   ),
        // });
        // priceContext.setPrice(array);
        props.product.finalAmount = formatNumber(
          rond(Math.round(parseInt(product.ojrat.replaceAll(",", ""))), rondVal)
        );
        return (
          <div className="row">
            <div className="col-5">{"(ریال) قیمت : "}</div>
            <div className="col-7 text-right">
              {formatNumber(
                rond(
                  Math.round(parseInt(product.ojrat.replaceAll(",", ""))),
                  rondVal
                )
              )}
            </div>
          </div>
        );
      } else if (product.type === "5") {
        const gold18 = parseInt(goldPrice);
        const dolar = parseInt(dolarPrice);
        const vazn = parseFloat(product.vaznBonak);
        const ayar = parseInt(product.ayar);
        const rial = parseFloat(product.mablagh);
        const mablaghDolar = parseFloat(product.mablaghSang);
        const darsadVazn = parseFloat(product.darsadVazn);
        const darsadRial = parseFloat(product.darsadRial);
        const darsadArz = parseFloat(product.darsadArz);
        const vaznToRial =
          ((vazn + (vazn * darsadVazn) / 100) * gold18 * ayar) / 750;
        const dolarToRial =
          (mablaghDolar + (mablaghDolar * darsadArz) / 100) * dolar;
        const A = Math.round(
          vaznToRial + dolarToRial + (rial + (rial * darsadRial) / 100)
        );
        const takhfif =
          parseFloat(loginContext.userInfo.darsad) +
          parseFloat(product.darsad_takhfif);
        const B = Math.round(A - (A * takhfif) / 100);

        const rondVal =
          product.rond === "0" || product.rond === "" ? 4 : product.rond;

        const detailArray = [];

        detailArray.push({ key: "فی طلا", value: formatNumber(gold18) });
        detailArray.push({ key: "وزن", value: vazn });
        detailArray.push({ key: "عیار", value: ayar });
        detailArray.push({
          key: "دلار",
          value: dolar,
        });

        if (props.type === "kala") {
          // const array = [...priceContext.price];
          // array.push({
          //   pk: product.pk,
          //   price: formatNumber(rond(B, rondVal)),
          // });
          props.product.finalAmount = formatNumber(rond(B, rondVal));
          return (
            <table>
              <tbody>
                {detailData.map((item, index) => (
                  <tr key={index}>
                    <th scope="row">{item.key}</th>
                    <td>{item.value}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          );
        } else {
          if (takhfif > 0) {
            return (
              <div className="row">
                <div className="col-5">
                  {"(ریال) قیمت : "}
                  <FontAwesomeIcon
                    icon={faMoneyBillWave}
                    size="lg"
                    onClick={() => {
                      setShowDetail(true);
                      setDetailData(detailArray);
                    }}
                  />
                  <Modal
                    show={showDetail}
                    onHide={() => {
                      setShowDetail(false);
                    }}
                    size="lg"
                    aria-labelledby="contained-modal-title-vcenter"
                    centered
                    scrollable
                  >
                    <Modal.Body
                      className={
                        theme === "light"
                          ? "bg-light text-dark"
                          : "bg-dark text-light"
                      }
                    >
                      <table
                        className={
                          theme === "light"
                            ? "table rtl text-dark"
                            : "table rtl text-light"
                        }
                      >
                        <tbody>
                          {detailData.map((item, index) => (
                            <tr key={index}>
                              <th scope="row">{item.key}</th>
                              <td>{item.value}</td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </Modal.Body>

                    <Modal.Footer
                      className={
                        theme === "light"
                          ? "bg-light text-dark"
                          : "bg-dark text-light"
                      }
                    >
                      <button
                        className="btn btn-dark"
                        onClick={() => {
                          setShowDetail(false);
                        }}
                      >
                        بستن
                      </button>
                    </Modal.Footer>
                  </Modal>
                </div>
                <div className="col-7 text-right">
                  {formatNumber(rond(B, rondVal))}
                </div>
                <div className="col-12 text-right">
                  <span className="badge badge-pill badge-danger">
                    {takhfif + "%"}
                  </span>
                  <small>
                    <del className="text-muted mr-1">
                      {formatNumber(rond(A, rondVal))}
                    </del>
                  </small>
                </div>
              </div>
            );
          } else {
            // const array = [...priceContext.price];
            // array.push({
            //   pk: product.pk,
            //   price: formatNumber(rond(A, rondVal)),
            // });
            props.product.finalAmount = formatNumber(rond(A, rondVal));
            return (
              <div className="row">
                <div className="col-5">
                  {"(ریال) قیمت : "}
                  <FontAwesomeIcon
                    icon={faMoneyBillWave}
                    size="lg"
                    onClick={() => {
                      setShowDetail(true);
                      setDetailData(detailArray);
                    }}
                  />
                  <Modal
                    show={showDetail}
                    onHide={() => {
                      setShowDetail(false);
                    }}
                    size="lg"
                    aria-labelledby="contained-modal-title-vcenter"
                    centered
                    scrollable
                  >
                    <Modal.Body
                      className={
                        theme === "light"
                          ? "bg-light text-dark"
                          : "bg-dark text-light"
                      }
                    >
                      <table
                        className={
                          theme === "light"
                            ? "table rtl text-dark"
                            : "table rtl text-light"
                        }
                      >
                        <tbody>
                          {detailData.map((item, index) => (
                            <tr key={index}>
                              <th scope="row">{item.key}</th>
                              <td>{item.value}</td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </Modal.Body>

                    <Modal.Footer
                      className={
                        theme === "light"
                          ? "bg-light text-dark"
                          : "bg-dark text-light"
                      }
                    >
                      <button
                        className="btn btn-dark"
                        onClick={() => {
                          setShowDetail(false);
                        }}
                      >
                        بستن
                      </button>
                    </Modal.Footer>
                  </Modal>
                  {/* {detail(detailArray)} */}
                </div>
                <div className="col-7 text-right">
                  {formatNumber(rond(A, rondVal))}
                </div>
              </div>
            );
          }
        }
      } else if (
        product.type === "61" ||
        product.type === "62" ||
        product.type === "63" ||
        product.type === "64" ||
        product.type === "65"
      ) {
        if (props.type === "bar") {
          return null;
        } else {
          if (product.type === "61") {
            // const array = [...priceContext.price];
            // array.push({
            //   pk: product.pk,
            //   price: formatNumber(
            //     rond(
            //       sekkePrice.sekkeJadid,
            //       product.rond === "0" ? 4 : product.rond
            //     )
            //   ),
            // });
            props.product.finalAmount = formatNumber(
              rond(
                sekkePrice.sekkeJadid,
                product.rond === "0" ? 4 : product.rond
              )
            );
            return (
              <div className="row">
                <div className="col-5">{"(ریال) قیمت : "}</div>
                <div className="col-7 text-right">
                  {formatNumber(
                    rond(
                      sekkePrice.sekkeJadid,
                      product.rond === "0" ? 4 : product.rond
                    )
                  )}
                </div>
              </div>
            );
          }
          if (product.type === "62") {
            // const array = [...priceContext.price];
            // array.push({
            //   pk: product.pk,
            //   price: formatNumber(
            //     rond(
            //       sekkePrice.sekkeGhadim,
            //       product.rond === "0" ? 4 : product.rond
            //     )
            //   ),
            // });
            props.product.finalAmount = formatNumber(
              rond(
                sekkePrice.sekkeGhadim,
                product.rond === "0" ? 4 : product.rond
              )
            );
            return (
              <div className="row">
                <div className="col-5">{"(ریال) قیمت : "}</div>
                <div className="col-7 text-right">
                  {formatNumber(
                    rond(
                      sekkePrice.sekkeGhadim,
                      product.rond === "0" ? 4 : product.rond
                    )
                  )}
                </div>
              </div>
            );
          }
          if (product.type === "63") {
            // const array = [...priceContext.price];
            // array.push({
            //   pk: product.pk,
            //   price: formatNumber(
            //     rond(sekkePrice.sekkeNim, product.rond === "0" ? 4 : product.rond)
            //   ),
            // });
            props.product.finalAmount = formatNumber(
              rond(sekkePrice.sekkeNim, product.rond === "0" ? 4 : product.rond)
            );
            return (
              <div className="row">
                <div className="col-5">{"(ریال) قیمت : "}</div>
                <div className="col-7 text-right">
                  {formatNumber(
                    rond(
                      sekkePrice.sekkeNim,
                      product.rond === "0" ? 4 : product.rond
                    )
                  )}
                </div>
              </div>
            );
          }
          if (product.type === "64") {
            // const array = [...priceContext.price];
            // array.push({
            //   pk: product.pk,
            //   price: formatNumber(
            //     rond(sekkePrice.sekkeRob, product.rond === "0" ? 4 : product.rond)
            //   ),
            // });
            props.product.finalAmount = formatNumber(
              rond(sekkePrice.sekkeRob, product.rond === "0" ? 4 : product.rond)
            );
            return (
              <div className="row">
                <div className="col-5">{"(ریال) قیمت : "}</div>
                <div className="col-7 text-right">
                  {formatNumber(
                    rond(
                      sekkePrice.sekkeRob,
                      product.rond === "0" ? 4 : product.rond
                    )
                  )}
                </div>
              </div>
            );
          }
          if (product.type === "65") {
            // const array = [...priceContext.price];
            // array.push({
            //   pk: product.pk,
            //   price: formatNumber(
            //     rond(
            //       sekkePrice.sekkeGerami,
            //       product.rond === "0" ? 4 : product.rond
            //     )
            //   ),
            // });
            props.product.finalAmount = formatNumber(
              rond(
                sekkePrice.sekkeGerami,
                product.rond === "0" ? 4 : product.rond
              )
            );
            return (
              <div className="row">
                <div className="col-5">{"(ریال) قیمت : "}</div>
                <div className="col-7 text-right">
                  {formatNumber(
                    rond(
                      sekkePrice.sekkeGerami,
                      product.rond === "0" ? 4 : product.rond
                    )
                  )}
                </div>
              </div>
            );
          }
        }
      } else {
        return null;
      }
    } else {
      if (props.type !== "bar" && dastresi!==4 && dastresi!==5) {
        return (
          <>
            <div className="text-center">
              <button
                onClick={() => setShowSignup(true)}
                className={theme === "light" ? "btn btn-dark" : "btn btn-light"}
              >
                مشاهده قیمت
              </button>
            </div>
            <Modal
              show={showSignup}
              onHide={() => {
                setShowSignup(false);
              }}
              size="sm"
              aria-labelledby="contained-modal-title-vcenter"
              centered
              scrollable
            >
              <Modal.Header
                closeButton
                className={
                  theme === "light"
                    ? "bg-light text-dark"
                    : "bg-dark text-light"
                }
              ></Modal.Header>
              <Modal.Body
                className={
                  theme === "light"
                    ? "bg-light text-dark"
                    : "bg-dark text-light"
                }
              >
                {modal()}
              </Modal.Body>
            </Modal>
          </>
        );
      } else {
        return null;
      }
    }
  } else {
    if (props.type !== "bar") {
      return (
        <>
          <div className="text-center">
            <button
              onClick={() => setShowSignup(true)}
              className={theme === "light" ? "btn btn-dark" : "btn btn-light"}
            >
              مشاهده قیمت
            </button>
          </div>
          <Modal
            show={showSignup}
            onHide={() => {
              setShowSignup(false);
            }}
            size="sm"
            aria-labelledby="contained-modal-title-vcenter"
            centered
            scrollable
          >
            <Modal.Header
              closeButton
              className={
                theme === "light" ? "bg-light text-dark" : "bg-dark text-light"
              }
            ></Modal.Header>
            <Modal.Body
              className={
                theme === "light" ? "bg-light text-dark" : "bg-dark text-light"
              }
            >
              {modal()}
            </Modal.Body>
          </Modal>
        </>
      );
    } else {
      return null;
    }
  }
};

export default Price;
